module.exports = "/packs/banner_sp_popular-015d713da87ced3db97e0045d5d267d5.png";